import moment from 'moment';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import AjaxHandler from '../../commons/ajax/AjaxHandler.js';

class TicketFormularios extends Component {
  constructor(props) {
    super(props);
    this.ajaxHandler = new AjaxHandler();
    this.state = {
      formularios: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.ajaxHandler.subscribe(this);
    if (this.props.ticket && this.props.ticket.id) {
      this.loadFormularios();
    }
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  loadFormularios() {
    this.ajaxHandler
      .getJson('/tickets/' + this.props.ticket.id + '/formularios')
      .then(data => {
        this.setState({ formularios: Array.isArray(data) ? data : [], loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    const { formularios, loading } = this.state;
    return (
      <div className="card pull-up">
        <div className="card-content pl-1 pr-1">
          <div className="card-body">
            <h4 className="form-section">
              <i className="la la-check-square"></i>
              <FormattedMessage
                id="ticketFormularios.render.header_checklists_asociados"
                defaultMessage=" Checklists asociados"
              />
            </h4>
            {loading ? null : formularios.length === 0 ? (
              <p>
                <FormattedMessage
                  id="ticketFormularios.render.label_no_hay_checklists_asociados"
                  defaultMessage="No hay checklists asociados."
                />
              </p>
            ) : (
              <table className="table table-sm table-hover">
                <thead className="thead-fleet">
                  <tr>
                    <th scope="col">
                      <FormattedMessage id="ticketFormularios.render.table_column_checklist" defaultMessage="Checklist" />
                    </th>
                    <th scope="col">
                      <FormattedMessage
                        id="ticketFormularios.render.table_column_fecha_respuesta"
                        defaultMessage="Fecha de respuesta"
                      />
                    </th>
                    <th scope="col">
                      <FormattedMessage id="ticketFormularios.render.table_column_usuario" defaultMessage="Usuario" />
                    </th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {formularios.map(f => (
                    <tr key={f.id}>
                      <td className="align-middle">{f.nombre_checklist}</td>
                      <td className="align-middle">{f.fecha_fin ? moment(f.fecha_fin).format('DD/MM/YYYY HH:mm') : '-'}</td>
                      <td className="align-middle">
                        {f.usuario_nombre
                          ? (f.usuario_nombre + ' ' + (f.usuario_apellido || '')).trim()
                          : '-'}
                      </td>
                      <td className="align-middle">
                        <a href={'/formulario/' + f.id} className="btn btn-icon text-fleet btn-sm btn-dt-grid p-0 m-0">
                          <i className="fa fa-search fa-xs"></i>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(TicketFormularios);
